
import { Inertia } from '@inertiajs/inertia'

export default {
  data: () => ({
    removeInertiaExceptionListener: () => {},
  }),

  created () {
    this.addInertiaExceptionListener()
  },

  destroyed () {
    this.removeInertiaExceptionListener()
  },

  methods: {
    addInertiaExceptionListener () {
      this.removeInertiaExceptionListener = Inertia.on('exception', event => {
        this.showInertiaException(this.$store.getters['translate']('connectionFailed'))
        event.preventDefault()
      })
    },
    showInertiaException (message) {
      console.warn(message) // may be overridden
    },
  },
}
